import React from "react";

/**
 * Official SafetyDesk81 brand mark.
 *
 * Uses the transparent PNG in /public/brand/. On dark surfaces the wordmark
 * would be unreadable (it's navy blue), so `variant="light"` renders it inside
 * a soft white pill that preserves the original colours (including the yellow "81").
 */
const LOGO_SRC = "/brand/logo-safetydesk81.webp";
const LOGO_ALT = "/brand/logo-safetydesk81.png";

const HEIGHTS = { sm: 22, md: 30, lg: 44, xl: 60 };

export function Logo({ variant = "dark", className = "", size = "md" }) {
    const h = HEIGHTS[size] || HEIGHTS.md;
    const isLight = variant === "light";

    const img = (
        <picture>
            <source srcSet={LOGO_SRC} type="image/webp" />
            <img
                src={LOGO_ALT}
                alt="SafetyDesk81"
                height={h}
                style={{ height: `${h}px`, width: "auto", display: "block" }}
                draggable={false}
            />
        </picture>
    );

    return (
        <span
            translate="no"
            aria-label="SafetyDesk81"
            className={`inline-flex items-center notranslate ${className}`}
            style={{ lineHeight: 1 }}
        >
            {isLight ? (
                <span
                    className="inline-flex items-center bg-white rounded-lg"
                    style={{ padding: "6px 12px" }}
                >
                    {img}
                </span>
            ) : (
                img
            )}
        </span>
    );
}
